import { render, staticRenderFns } from "./kswitch.vue?vue&type=template&id=369dd73b&scoped=true&"
import script from "./kswitch.vue?vue&type=script&lang=js&"
export * from "./kswitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369dd73b",
  null
  
)

export default component.exports